export const MAX_NUMBER_FIELDS_NUMBER = 1_000_000
